import React from "react";
import Navbar from "../pagesections/Navbar";
import Herocontenta from "./Herocontenta";

function Heroabout() {
  return (
    <>
    <Navbar />
    <div className="hero-sec-container">
      
      <Herocontenta />
    </div>
    </>
  );
}

export default Heroabout;
